// Only play banner videos while their selected slide is visible on screen.
(() => {
  if (window.slideshowVideosInitialized) return;
  window.slideshowVideosInitialized = true;

  const initialize = (root) => {
    root.querySelectorAll('slideshow-carousel').forEach((carousel) => {
      const videos = carousel.querySelectorAll('video.slideshow__video');
      if (!videos.length || carousel.dataset.videosInitialized) return;
      carousel.dataset.videosInitialized = 'true';

      const desktopBreakpoint = window.matchMedia('(min-width: 700px)');
      let visible = false;
      const update = () => {
        videos.forEach((video) => {
          if (visible && !document.hidden && getComputedStyle(video).display !== 'none' && video.closest('.slideshow__slide').classList.contains('is-selected')) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };
      const intersectionObserver = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        update();
      });
      const mutationObserver = new MutationObserver(update);
      carousel.querySelectorAll('.slideshow__slide').forEach((slide) => {
        mutationObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
      intersectionObserver.observe(carousel);
      document.addEventListener('visibilitychange', update);
      desktopBreakpoint.addEventListener('change', update);

      const section = carousel.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => {
        intersectionObserver.disconnect();
        mutationObserver.disconnect();
        document.removeEventListener('visibilitychange', update);
        desktopBreakpoint.removeEventListener('change', update);
        videos.forEach((video) => video.pause());
      }, { once: true });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
